module.exports = __webpack_public_path__ + "img/angst_1600.13283968.webp";